import { Component } from '@angular/core';
import { EmployeeDashboardService } from '../../services/employee-dashboard.service';

@Component({
    selector: 'app-team-metrics',
    templateUrl: './team-metrics.component.html',
    styleUrls: ['./team-metrics.component.css'],
    standalone: false
})
export class TeamMetricsComponent {

   issues = 0;

  constructor(
    private dashboardService: EmployeeDashboardService
  ) {}

  ngOnInit(): void {
    // this.http.get<{ issues: number }>('/api/team/metrics')
    //   .subscribe(res => this.issues = res.issues);
  }

  resolveIssue() {
    // this.http.post('/api/team/metrics/resolve', {})
    //   .subscribe(() => {
    //     this.issues--;
    //     this.dashboardService.decrement('attendance');
    //   });
  }

}
